/**
 * This file is meant for JS scripts that override or enhance some default
 *  Drupal behaviors.
 */
(function ($, Drupal, once) {

  'use strict';
  /**
   * This works with side-image class.
   */
  Drupal.behaviors.promutuel_drupalOverrides = {
    attach: function attach(context) {

      const adminToolbar = document.getElementById('toolbar-item-administration-tray');

      $(once('promutuel_drupalOverrides', adminToolbar, context)).each(function() {
        // Allow closing the admin toolbar by clicking inside it, but outside menu items.
        // This is especially useful when switching between dsktop and mobile display.
        adminToolbar.addEventListener('click', function (event) {
          if (!event.target.closest('.toolbar-menu')) document.querySelector('.toolbar-icon-menu')?.click();
        });
      });
    }
  };
})(jQuery, Drupal, once);
